import $ from 'jquery';

import 'slick-slider';

$(document).ready(() => {
	$('.gallery').slick({
		arrows: true,
	});
});
